export const list = state => state.list;
export const ticket = state => state.ticket;
export const currentPage = state => state.currentPage;
export const totalResources = state => state.totalResources;
export const limitOptions = state => state.limitOptions;
export const limit = state => state.limit;
export const loadingData = state => state.loadingData;
export const newTicketId = state => state.newTicketId;
export const messages = state => state.messages;
export const hasNotification = state => state.hasNotification;

export const filter = (state) => {
  const filters = {
    page: (state.currentPage || 1),
    limit: state.limit,
  };
  return filters;
};
export const pagination = (state) => {
  const page = {
    page: state.currentPage,
    rowsPerPage: state.limitOptions,
    totalItems: state.totalResources,
  };
  return page;
};
